import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { loanDisbursementService } from 'app/apps/ben-loan-management/loan-disbursement/loan-disbursement-service';
import { ApiService } from 'app/providers/api.service';
@Component({
  selector: 'app-payment-success',
  templateUrl: './payment-success.component.html',
  styleUrls: ['./payment-success.component.scss']
})
export class PaymentSuccessComponent {
  today = new Date();
  paymentsDetails: any = {};
  params_data: any = {};
  usrDtls;
  constructor(private activateroute: ActivatedRoute,
    private router: Router,
    private apiSrvc: ApiService,
    private lnsrvc: loanDisbursementService
  ) {

    this.activateroute.params.subscribe((k) => {
      this.params_data = k;
      this.getPaymentDetailswithDetails(k);
    });
    this.usrDtls = JSON.parse(localStorage.getItem('userdata'));



  }

  pymt_typ = '';


  getPaymentDetailswithDetails = (obj = null) => {


    if(this.usrDtls && this.usrDtls.roles['rle_nm'] ==  'BCCFC Benificary '){
      this.pymt_typ = '';
    }else{
      this.pymt_typ = '/ben_contr_pmnt';
    }
    this.apiSrvc.get(`payment/receipts/details/${obj.status}/${obj.orderId}${this.pymt_typ}`).subscribe({
      next: (res) => {
        if (res[`status`] == 200) {
          this.paymentsDetails = res[`data`][0];
          console.log(this.paymentsDetails);
          
       

        }
      },
      error: (error) => {

      }
    })

  }


  onBack = () => {
    
    if(this.usrDtls && this.usrDtls.roles['rle_nm'] ==  'BCCFC Benificary '){
      this.router.navigate(['/apps/dashboards/beneficiary_profile_Dashboard'], { queryParams: { bnfcy_id: this.paymentsDetails.bnfcy_id } });
    } else {
      console.log(this.paymentsDetails);
      if(this.paymentsDetails){
      console.log('else eeeeeeeeee ', this.paymentsDetails);
        this.lnsrvc.updatePaymentDetails(this.paymentsDetails);
        this.router.navigate(['/apps/loan-ben/loan/EMI'], { queryParams: { bnfcy_id: this.paymentsDetails.bnfcy_id } });
      }
    }

  }




}
